export const VALIDE_PAYLOAD = { status: 'VALIDE' }
export const PUBLISH_PAYLOAD = { status: 'PUBLIE' }
